import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { format } from 'date-fns';
import { useMemo } from 'react';
const invalidDayData = {
    date: '',
    price: 0,
    currency: '',
    isAvailable: false,
    restrictions: {
        minLengthOfStay: 0,
        maxLengthOfStay: 0,
        closed: true,
        closedOnArrival: true,
        closedOnDeparture: true,
    },
    allowArrival: false,
    allowDeparture: false,
    dayOfMonth: 0,
    week: 0,
    weekday: 1,
};
export const CalendarDay = (props) => {
    const { day, options, onClick, onHover } = props;
    const data = day || invalidDayData;
    const dayOfMonth = day ? day.dayOfMonth : '';
    // this day is valid - if it is a day of this month and is not in the past
    const isValidDay = (day === null) || (day.date >= format(Date.now(), 'yyyy-MM-dd'));
    const restrictions = data.restrictions;
    const isAvailable = (data.isAvailable && !restrictions.closed);
    const renderPrice = (price, currency) => {
        // TODO: toFixed should respect the currency >> not all currencies have 'cents'
        return (_jsxs("span", { className: "ibe-calendar-day-price", children: [price.toFixed(2), " ", currency] }));
    };
    const renderInOut = (options) => {
        const text = options.isCheckIn ? 'IN' : (options.isCheckOut ? 'OUT' : '');
        return _jsx("div", { className: "ibe-calendar-in-out-label", children: text });
    };
    const ibeClassNames = useMemo(() => {
        const classes = ['ibe-calendar-day'];
        if (isValidDay) {
            if (options.isCheckIn) {
                classes.push('ibe-calendar-day-arrival-date');
            }
            if (options.isCheckOut) {
                classes.push('ibe-calendar-day-departure-date');
            }
            if (restrictions.closedOnArrival) {
                classes.push('ibe-calendar-day-coa');
            }
            if (restrictions.closedOnDeparture) {
                classes.push('ibe-calendar-day-cod');
            }
            if (restrictions.closed) {
                classes.push('ibe-no-availability');
            }
            if (restrictions.minLengthOfStay) {
                classes.push(`ibe-calendar-min-stay-${restrictions.minLengthOfStay}`);
            }
            if (restrictions.maxLengthOfStay) {
                classes.push(`ibe-calendar-max-stay-${restrictions.maxLengthOfStay}`);
            }
            if (data.allowArrival) {
                classes.push('ibe-allow-arrival');
            }
            if (options.enabled) {
                classes.push('ibe-calendar-day-enabled');
            }
            if (options.selected) {
                classes.push('ibe-calendar-day-stay-date');
            }
            else if (!isAvailable) {
                if (data.allowDeparture) {
                    classes.push('ibe-allow-departure');
                }
                else {
                    classes.push('ibe-no-availability');
                }
            }
            if (options.preview) {
                classes.push('ibe-calendar-day-preview');
            }
            if (options.afterCheckIn) {
                classes.push('ibe-calendar-day-after-arrival');
            }
        }
        return classes.join(' ');
    }, [day, options]);
    const handleClick = () => {
        if (day && options.enabled && isValidDay) {
            onClick(day);
        }
    };
    const handleHover = (hovering) => {
        if (day && onHover) {
            onHover(day, hovering);
        }
    };
    const handleHoverStart = () => {
        handleHover(true);
    };
    const handleHoverStop = () => {
        handleHover(false);
    };
    return day
        ? (_jsxs("div", { className: ibeClassNames, onClick: handleClick, onMouseEnter: handleHoverStart, onMouseLeave: handleHoverStop, children: [renderInOut(options), _jsx("span", { className: "ibe-calendar-day-number-label", children: dayOfMonth }), renderPrice(data.price, data.currency)] }))
        : null;
};
//# sourceMappingURL=MyIbeCalendarDay.js.map